module.exports = __webpack_public_path__ + "static/media/ic_video_off_small_transparent.0b3ab6bb.svg";